export default import.meta.ROLLUP_FILE_URL__ewJD0zO9$SsiDvawfmAUw;